import { organizationEntityName } from '../../../../backend/features/organizations/shared';
import { useContactManagementTranslation } from '../../../../ui/hooks';
import { getConfig } from '@juvare/common-web-ui/config';
import { mapAdvancedSearchOpToStringColumnFilter, useAdvancedSearchDynamicFilters, useAdvancedSearchTextFieldOperatorOptions, } from '@juvare/platform-sdk-react/ui/features/advanced-search';
export const getDefaultAdvancedSearchItems = (t, textFieldOperatorOptions) => [
    {
        label: t('panels.accounts.filterLabels.firstName'),
        value: 'firstName',
        operatorOptions: textFieldOperatorOptions,
        onGetStorageFilter: (operator, value) => mapAdvancedSearchOpToStringColumnFilter('firstName', operator, value),
    },
    {
        label: t('panels.accounts.filterLabels.lastName'),
        value: 'lastName',
        operatorOptions: textFieldOperatorOptions,
        onGetStorageFilter: (operator, value) => mapAdvancedSearchOpToStringColumnFilter('lastName', operator, value),
    },
    {
        label: t('panels.accounts.filterLabels.email'),
        value: 'email',
        operatorOptions: textFieldOperatorOptions,
        onGetStorageFilter: (operator, value) => mapAdvancedSearchOpToStringColumnFilter('email', operator, value),
    },
    {
        label: t('panels.accounts.filterLabels.organizationName'),
        value: 'organizationName',
        operatorOptions: textFieldOperatorOptions,
        onGetStorageFilter: (operator, value) => {
            const storageFilter = {
                column: 'orgMembership',
                op: operator.startsWith('not') ? 'contained' : 'overlap',
                subFilter: {
                    entity: organizationEntityName,
                    filter: [mapAdvancedSearchOpToStringColumnFilter('name', operator, value)],
                },
            };
            if (operator.startsWith('not')) {
                return {
                    op: 'or',
                    filter: [{ column: 'orgMembership', op: '=', value: [] }, storageFilter],
                };
            }
            return storageFilter;
        },
    },
];
export const useDefaultAdvancedSearchItems = () => {
    const { t } = useContactManagementTranslation();
    const { contactManagement } = getConfig();
    let advancedSearchItems = getDefaultAdvancedSearchItems(t, useAdvancedSearchTextFieldOperatorOptions());
    const advancedSearchDynamicFilters = useAdvancedSearchDynamicFilters(contactManagement.dynamicColumns);
    if (advancedSearchDynamicFilters) {
        advancedSearchItems = [...advancedSearchItems, ...advancedSearchDynamicFilters];
    }
    return advancedSearchItems;
};
